import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../../parts/modal-new";
import TemplateSelectionList from "../components/TemplateSelectionList";

const ReplaceOptionFromTemplateModal = ({ locals }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const { mealPlanTemplates = [], query, mealPlan } = locals;
  const { dayType, optionId, mealPlan: mealPlanId, athlete, hasFoods } = query;
  const isEmpty = !(hasFoods === "true" || hasFoods === true);

  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  /**
   * Handle template selection
   */
  const handleTemplateSelect = (templateId) => {
    setSelectedTemplateId(templateId);
  };

  /**
   * Handle save
   */
  const handleSave = () => {
    if (!selectedTemplateId) return;

    const mealPlanIdToUse = mealPlanId || mealPlan?._id;
    if (!mealPlanIdToUse) {
      console.error("mealPlanId is required");
      return;
    }

    if (typeof dayType !== "string" || !["training", "rest"].includes(dayType)) {
      console.error("Invalid dayType");
      return;
    }

    if (!optionId) {
      console.error("Invalid optionId");
      return;
    }

    const body = {
      templateId: selectedTemplateId,
      dayType: dayType,
      optionId: optionId,
    };

    submit(
      `/actions/meal-planner/replace-option-from-template?mealPlanId=${mealPlanIdToUse}&proxyAthlete=${athlete || ""}`,
      {
        method: "POST",
        body,
      }
    );
  };

  return (
    <Modal
      className="replace-option-from-template"
      title={t(
        isEmpty
          ? "athlete-portal:replaceOptionFromTemplateModal.titleEmpty"
          : "athlete-portal:replaceOptionFromTemplateModal.title"
      )}
      toClear={[]}
    >
      <div className="body">
        {mealPlanTemplates.length > 0 && (
          <div className="description">
            <span>
              {t("athlete-portal:replaceOptionFromTemplateModal.description")}
            </span>
          </div>
        )}
        <TemplateSelectionList
          templates={mealPlanTemplates}
          selectedTemplateId={selectedTemplateId}
          onSelect={handleTemplateSelect}
          onSave={handleSave}
          emptyStateTitleKey="athlete-portal:replaceOptionFromTemplateModal.noTemplatesTitle"
          emptyStateDescriptionKey="athlete-portal:replaceOptionFromTemplateModal.noTemplatesDescription"
        />
      </div>
    </Modal>
  );
};

ReplaceOptionFromTemplateModal.propTypes = {
  locals: PropTypes.object,
};

export default ReplaceOptionFromTemplateModal;
